import { render, staticRenderFns } from "./attributeTable.vue?vue&type=template&id=15b5ca97&scoped=true"
import script from "./attributeTable.vue?vue&type=script&lang=js"
export * from "./attributeTable.vue?vue&type=script&lang=js"
import style0 from "./attributeTable.vue?vue&type=style&index=0&id=15b5ca97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b5ca97",
  null
  
)

export default component.exports